
import { computed, defineComponent, inject, onUnmounted, ref, watch } from 'vue'
import * as StorageConstants from '@/constants/storage-constants'
import { useStore } from '@/store'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'Instruction',
  setup() {
    const store = useStore()
    const emitter: any = inject('emitter')
    const isVieworder = inject('isVieworder') as boolean
    const isThreeMode = computed(() => store.getters.isThreeMode)
    const loadConfig = computed(() => store.getters.loadConfig)
    const visible = ref(false)
    let path = ref('instruction_fullorder_3d.png')
    let pathMobile = ref('instruction_fullorder_3d_mobile.png')

    emitter.on('showInstruction', showInstruction)
    emitter.on('hideDialogs', hide)

    // prettier-ignore
    watch(() => loadConfig.value, (_) => {
        let firstVisit = true
        try {
          firstVisit = localStorage.getItem(StorageConstants.firstVisit) == undefined
        }
        catch(err) {
          // on some browser like LINE, there is no localstorage; ignore that error
          firstVisit = true
        }

        try {
          if (firstVisit) {
            showInstruction()
            localStorage.setItem(StorageConstants.firstVisit, 'true')
          }
        } catch (err) {
          SentrySingleton.instance.captureException(err)
        }
      }
    )

    function showInstruction() {
      visible.value = true
      const fileName = determineFilename()
      path.value = fileName + '.png'
      pathMobile.value = fileName + '_mobile.png'
      setTimeout(() => {
        emitter.emit('showOverlay') // hackfix: needed when show instruction from a dialog
      }, 200)
    }

    function determineFilename() {
      if (isVieworder && isThreeMode.value) {
        return 'instruction_vieworder_3d'
      } else if (isVieworder && !isThreeMode.value) {
        return 'instruction_vieworder_2d'
      } else if (!isVieworder && isThreeMode.value) {
        return 'instruction_fullorder_3d'
      } else if (!isVieworder && !isThreeMode.value) {
        return 'instruction_fullorder_2d'
      } else {
        console.warn('unkown instruction image')
        SentrySingleton.instance.captureException('instruction.vue: unkown instruction image')
        return 'instruction_fullorder_3d'
      }
    }

    const onClick = () => {
      hide()
      emitter.emit('hideOverlay')
    }

    function hide() {
      if (visible.value) {
        emitter.emit('onHideInstruction')
      }
      visible.value = false
    }

    onUnmounted(() => {
      emitter.off('hideDialogs', hide)
      emitter.off('showInstruction', showInstruction)
    })

    return {
      visible,
      path,
      pathMobile,
      onClick
    }
  }
})
